import React from 'react';

import {
  Typography
} from '@mui/material';
import useClasses from '../../helpers/useClasses';


const styles = theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  terms: {
    height: '400px',
    overflow: 'scroll'
  }
});

const Terms2  = (props) => {
  const classes = useClasses(styles);

  return (
    <React.Fragment>
      <Typography
        variant="h4"
      >
        TERMS OF USE AGREEMENT
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Last Modified: 02-25-2026
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        This Terms of Use Agreement (this "Agreement") is a binding contract between you ("Customer," "User," "Developer," "Integration Partner," "you," or "your") and Datamerch, LLC (“Company”, "we," "us," or "our"). This Agreement governs your access to and use of datamerch.com (the "Site") and the information services, data, and content provided by Company or third parties (collectively, the "Services"). The defined terms of this Agreement are listed in Section 1. Please read these terms carefully and keep a copy of them for your reference.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        THIS AGREEMENT TAKES EFFECT WHEN YOU EXECUTE AN ORDER FORM BY SIGNING UP THROUGH THE ONLINE SIGN-UP PAGE, OR BY ACCESSING OR USING THE SERVICES (the "Effective Date"). BY EXECUTING AN ORDER FORM, OR BY ACCESSING OR USING THE SERVICES YOU (A) ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTAND THIS AGREEMENT; (B) REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT, POWER, AND AUTHORITY TO ENTER INTO THIS AGREEMENT AND, IF ENTERING INTO THIS AGREEMENT FOR AN ORGANIZATION, THAT YOU HAVE THE LEGAL AUTHORITY TO BIND THAT ORGANIZATION; AND (C) ACCEPT THIS AGREEMENT AND AGREE THAT YOU ARE LEGALLY BOUND BY ITS TERMS. IF YOU DO NOT ACCEPT THESE TERMS, YOU MAY NOT ACCESS OR USE THE SERVICES.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        THESE TERMS CONTAIN A DISPUTE RESOLUTION AND ARBITRATION PROVISION, INCLUDING A CLASS ACTION WAIVER THAT AFFECTS YOUR RIGHTS UNDER THESE TERMS AND WITH RESPECT TO DISPUTES YOU MAY HAVE WITH US. IF YOU WISH TO OPT OUT OF BINDING ARBITRATION, PLEASE EMAIL US AT [SUPPORT EMAIL] AND LET US KNOW WITHIN 30 DAYS OF YOUR INITIAL ACCEPTANCE OF THIS AGREEMENT.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        I. FCRA AND COMMERCIAL DATA DISCLAIMER
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Company does not constitute a "consumer reporting agency" as that term is defined in the federal Fair Credit Reporting Act, 15 USC 1681 et seq. (FCRA). Company does not, for monetary fees, dues, or on a cooperative nonprofit basis, engage in whole or in part in the practice of assembling or evaluating consumer credit information or other information on consumers for the purpose of furnishing consumer reports to third parties, and which uses any means or facility of interstate commerce for the purpose of preparing or furnishing consumer reports. Company only accepts, stores, and distributes data on commercial entities. User is prohibited from providing information on individual persons or consumers. Information listed on the Site may not be used in whole or in part as a factor in determining eligibility for personal credit, insurance, employment or another permissible purpose under the FCRA. It is the policy of Company to view sole-proprietors, single-shareholder corporations, single-member partnerships and single-member companies as commercial entities and never as individuals or consumers. the Site is an information Site that shares data on merchants in the alternative business financing industry.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        II. TERMS OF USE
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        1. Definitions.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>"API Credentials"</b> means the secure keys, access tokens, client IDs, and client secrets issued by Company to Customer or a Developer to allow authentication and access to the Services or Sandbox via an application programming interface.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>"Authorized User"</b> means Customer and Customer's employees, consultants, contractors, and agents (i) who are authorized by Customer to access and use the Services under the rights granted to Customer pursuant to this Agreement, (ii) for whom access to the Services has been purchased hereunder, and (iii) identified in the Account portal or this Agreement.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>"Company IP"</b> means the Services, the Site, the Documentation, and all intellectual property provided to Customer or any other Authorized User in connection with the foregoing. Company IP includes original works of authorship, including compiled information containing Company selection, arrangement and coordination and expressions of such information or pre-existing material it has created, gathered or assembled; trade secret and other confidential information; and Aggregated Statistics and any information, data, or other content derived from Company's monitoring of Customer's access to or use of the Services, but does not include Customer Data.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>"Customer Data"</b> or <b>"Submissions"</b> means, other than Aggregated Statistics, information, data, and other content, in any form or medium, that is submitted, posted, or otherwise transmitted by or on behalf of Customer or any other Authorized User through the Services, including the submission of Customer Data to the Site for search purposes.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (e) <b>"Developer"</b> means a third-party technology provider or integration partner that accesses the Sandbox or the Production Environment for the purpose of building or maintaining an integration with the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (f) <b>"End Customer"</b> means the specific commercial entity that is the owner of the Account and the subscriber to the Services under an Order Form.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (g) <b>"Integration Partner"</b> means a Developer that has been authorized by an End Customer to access the Services on that End Customer’s behalf using the End Customer’s API Credentials.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (h) <b>"Documentation"</b> means Company's end user documentation relating to the Services available on the Site.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (i) <b>"Merchant"</b> means the commercial business entity (including, for avoidance of doubt, a sole proprietorship treated as a commercial entity) that is the subject of a Record (as defined in the Dispute Policy referenced in Section 17) made available through the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (j) <b>"Production Environment"</b> means the live version of the Services containing real-world data and accessible only by paid subscription.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (k) <b>"Sandbox"</b> means the non-production, test environment of the Services provided by Company for development and testing purposes.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (l) <b>"Order Form"</b> means the initial sign-up page including the subscription options specifying the Services to be provided hereunder that is entered into between Customer and Company, including any addenda and supplements thereto.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (m) <b>"Services"</b> means the information services, information, and other content provided by Company under this Agreement that are detailed on the Site and reflected in the Customer's Order Form.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (n) <b>"Third-Party Products"</b> means any products, content, services, information, websites (including "Linked Sites"), or other materials that are owned by third parties and are incorporated into or accessible through the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        2. Access and Use.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Provision of Access (Production)</b>. Subject to terms and conditions of this Agreement, Company hereby grants you a revocable, non-exclusive, non-transferable, non-sublicensable, limited right to access and use the Services during the Term strictly in accordance with these terms of use and solely for your internal business operations by Authorized Users. Company shall provide you the necessary passwords and access credentials to allow you to access the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Developer Sandbox; Non-Production Use</b>. If Company provides you with access to the Sandbox, Company hereby grants you a revocable, non-exclusive, non-transferable, limited right to access and use the Sandbox solely for the purpose of testing, developing, and validating integrations with the Services. You acknowledge and agree that: (i) the Sandbox utilizes dummy or test data only and does not provide access to the Production Environment or real Merchant data; (ii) you shall not use the Sandbox for any live business operations or production purposes; (iii) Company has no obligation to retain any data submitted to the Sandbox and may wipe, reset, or change the Sandbox environment at any time without notice; and (iv) the Sandbox is provided "AS IS" without warranty of any kind. You must not attempt to use Sandbox API Credentials to access the Production Environment or vice versa. Company reserves the right to revoke Sandbox access at any time in its sole discretion.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>Documentation License</b>. Subject to the terms and conditions contained in this Agreement, Company hereby grants you a non-exclusive, non-sublicensable, non-transferable license for Authorized Users to use the Documentation during the Term solely for your internal business purposes in connection with use of the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>Use Restrictions</b>. You shall not, and shall not permit any Authorized Users or Integration Partners to, use the Services, any software component of the Services, or Documentation for any purposes beyond the scope of the access granted in this Agreement. You shall not at any time, directly or indirectly, and shall not permit any Authorized Users to: (i) copy, modify, or create derivative works of the Services, any software component of the Services, or Documentation, in whole or in part; (ii) rent, lease, lend, sell, license, sublicense, assign, distribute, publish, transfer, or otherwise make available the Services or Documentation except as expressly permitted under this Agreement; (iii) reverse engineer, disassemble, decompile, decode, adapt, or otherwise attempt to derive or gain access to any software component of the Services, in whole or in part; (iv) remove any proprietary notices from the Services or Documentation; (v) use the Services or Documentation in any manner or for any purpose that infringes, misappropriates, or otherwise violates any intellectual property right or other right of any person, or that violates any applicable law, regulation, or rule; (vi) use the Site in any manner which could damage, disable, overburden, or impair the Site or interfere with any other party's use and enjoyment of the Site; or (vii) obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Site.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (e) <b>Aggregated Statistics</b>. Notwithstanding anything to the contrary in this Agreement, Company may monitor Customer's use of the Services and collect and compile data and information related to Customer's use of the Services to be used by Company in an aggregated and anonymized manner, including to compile statistical and performance information related to the provision and operation of the Services ("Aggregated Statistics"). As between Company and Customer, all right, title, and interest in Aggregated Statistics, and all intellectual property rights therein, belong to and are retained solely by Company. You acknowledge that Company may compile Aggregated Statistics based on Customer Data input into the Services. You agree that Company may (i) make Aggregated Statistics publicly available in compliance with applicable law, and (ii) use Aggregated Statistics to the extent and in the manner permitted under applicable law; provided that such Aggregated Statistics do not identify Customer or Customer's Confidential Information.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (f) <b>Reservation of Rights</b>. Company reserves all rights not expressly granted to Customer in this Agreement. Except for the limited rights and licenses expressly granted under this Agreement, nothing in this Agreement grants, by implication, waiver, estoppel, or otherwise, to Customer or any third party, any intellectual property rights or other right, title, or interest in or to the Company IP.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (g) <b>Suspension</b>. Notwithstanding anything to the contrary in this Agreement, Company may temporarily suspend Customer's and any other Authorized User's access to any portion or all of the Services if: (i) Company reasonably determines that (A) there is a threat or attack on any of the Company IP; (B) Customer's or any other Authorized User's use of the Company IP disrupts or poses a security risk to the Company IP or to any other customer or vendor of Company; (C) Customer or any other Authorized User is using the Company IP for fraudulent or illegal activities; (D) subject to applicable law, Customer has ceased to continue its business in the ordinary course, made an assignment for the benefit of creditors or similar disposition of its assets, or become the subject of any bankruptcy, reorganization, liquidation, dissolution, or similar proceeding; or (E) Company's provision of the Services to Customer or any other Authorized User is prohibited by applicable law; (ii) any vendor of Company has suspended or terminated Company's access to or use of any third-party services or products required to enable Customer to access the Services; or (iii) in accordance with Section 6 (any such suspension described in subclause (i), (ii), or (iii), a "Service Suspension"). Company shall use commercially reasonable efforts to provide written notice of any Service Suspension to Customer and to provide updates regarding resumption of access to the Services following any Service Suspension. Company shall use commercially reasonable efforts to resume providing access to the Services as soon as reasonably possible after the event giving rise to the Service Suspension is cured. Company will have no liability for any damage, liabilities, losses (including any loss of or profits), or any other consequences that Customer or any other Authorized User may incur as a result of a Service Suspension.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (h) <b>Access Restriction</b>. Access to and use of password protected and/or secure areas of the Site is restricted to authorized users only. Only authorized adults eighteen (18) years of age or older are permitted to create accounts or use the Services. Minors under the age of 18 are strictly prohibited from using the Services or providing any data to the Site. Company does not knowingly collect information from persons under the age of 18.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        3. Integration Partners; Use of API Credentials.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Permitted Integration Use</b>. An Integration Partner may use the Services and API Credentials solely to integrate the Services into a software application or platform for the direct benefit of the specific End Customer to whom the API Credentials belong. An Integration Partner is not an "Authorized User" of the End Customer unless expressly authorized by the End Customer and limited to use of the End Customer's account.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>No Credential Pooling; No Subscription Circumvention</b>. Integration Partners and Customers are strictly prohibited from: (i) sharing API Credentials among multiple distinct legal entities or customers; (ii) "pooling," "multiplexing," or otherwise using a single End Customer’s API Credentials to access the Services for the benefit of any person or entity other than that specific End Customer; (iii) operating a service bureau, white-label service, or otherwise reselling or redistributing the Services to third parties using a single account; or (iv) taking any action intended to circumvent Company’s subscription model or per-customer fee structure. Each End Customer accessing the Production Environment, whether directly or through an Integration Partner’s platform, must maintain its own active, paid subscription with Company.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>Authorization and Records</b>. Integration Partner represents and warrants that it has obtained written authorization from each End Customer to access the Services on such End Customer’s behalf. Integration Partner must maintain records of such authorizations and provide them to Company upon request.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>Security and Privacy</b>. Integration Partners and Developers must: (i) maintain reasonable security controls to protect API Credentials (including, without limitation, prohibiting the hardcoding of credentials in public repositories, ensuring secure storage, and adhering to rotation practices); (ii) comply with Company’s Privacy Policy and all applicable privacy laws; and (iii) immediately notify Company of any suspected or actual compromise or misuse of API Credentials.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (e) <b>Compliance and Monitoring</b>. Company reserves the right to monitor the use of API Credentials and the Services to verify compliance with this Section 3. Upon Company’s reasonable request, Customer or Integration Partner shall provide a written attestation or list of End Customers to confirm that unique credentials are being used for each distinct End Customer.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        4. Customer Responsibilities.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Acceptable Use</b>. The Services may not be used for unlawful, fraudulent, offensive, or obscene activity. You will comply with all terms and conditions of this Agreement, all applicable laws, rules, and regulations, and all guidelines, standards, and requirements that may be posted on the Site from time to time. User agrees not to use the facilities and capabilities of the website to conduct any business or activity or solicit the performance of any activity that is prohibited by law or to solicit users to become users of other competitive information services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Account Use</b>. You are responsible and liable for all uses of the Services and Documentation resulting from access provided by you, directly or indirectly, whether such access or use is permitted by or in violation of this Agreement. Without limiting the generality of the foregoing, you are responsible for all acts and omissions of Authorized Users and Integration Partners using your API Credentials, and any act or omission by an Authorized User or Integration Partner that would constitute a breach of this Agreement if taken by you will be deemed a breach of this Agreement by you. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer, and you agree to accept responsibility for all activities that occur under your account or password and to indemnify Company for any damages caused by the use of your account, password or computer. You acknowledge that Company is not responsible for third party access to your account that results from theft or misappropriation of your account. Company and its associates reserve the right to refuse or cancel service, terminate accounts, or remove or edit content in our sole discretion.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>Customer Data and Submissions</b>. To facilitate the operation of the Services, Customer hereby grants to Company a non-exclusive, royalty-free, worldwide license to host, reproduce, distribute, and otherwise use, collect and process the Customer Data as necessary for Company to provide the Services. Customer further grants a non-exclusive, perpetual, irrevocable, royalty-free, worldwide license to Company to use Customer Data incorporated within Aggregated Statistics or collective works.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        You grant Company permission to use your name for attribution purposes. You will ensure that Customer Data and any Authorized User's use of Customer Data will not violate any policy or terms referenced in or incorporated into this Agreement or any applicable law. You are solely responsible for the development, content, operation, maintenance, and use of Customer Data. You agree to represent yourself accurately and acknowledge that misrepresentation may lead Company, at its sole discretion, to cancel your use of the services and delete any of your content. No compensation will be paid with respect to the use of your Submission.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>Passwords and API Credentials; Credential Sharing Prohibited</b>. You are responsible for keeping all passwords, API credentials, and login links associated with the Services confidential and secure. You will not share, disclose, sell, assign, sublicense, rent, lease, transfer, or otherwise make available any passwords or API credentials to any other person or entity, including any third-party company, except to (i) Authorized Users who are permitted under this Agreement and for whom access to the Services has been purchased, and (ii) Authorized Integration Partners strictly in accordance with Section 3. You will promptly notify us of any actual or suspected unauthorized access to or use of your account, passwords, or access credentials.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (e) <b>Third-Party Products</b>. The Services may permit access to Third-Party Products (Linked Sites). For purposes of this Agreement, such Third-Party Products are subject to their own terms and conditions presented to you by website link or otherwise. Company is not responsible for the contents of any Linked Site, including without limitation any link contained in a Linked Site, or any changes or updates to a Linked Site. By using any product, service or functionality originating from the Site domain, you hereby acknowledge and consent that Company may share such information and data with any third party with whom Company has a contractual relationship to provide the requested product, service or functionality on behalf of users and customers.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (f) <b>Record Keeping</b>. User agrees to maintain independent original records of all information or data posted or uploaded to the Site and will submit the same to Company upon request. In the event a third party challenges the accuracy or validity of the information or data posted or uploaded by User or alleges damages as a result of the information or data posted or uploaded by User, then User agrees to fully cooperate with and indemnify Company. Cooperation includes, but is not limited to, communicating with Company regarding the challenged information or data and providing proof of the accuracy of the challenged information or data. In the event a third party challenges the accuracy or validity of the information or data posted or uploaded by User, User agrees to fully cooperate with Company, including communicating regarding the challenged data and providing proof of accuracy.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        5. Use of Communication Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        The Site may contain bulletin board services, chat areas, news groups, forums, communities, personal web pages, calendars, and/or other message or communication facilities designed to enable you to communicate with the public at large or with a group (collectively, "Communication Services"). You agree to use the Communication Services only to post, send and receive messages and material that are proper and related to the particular Communication Service. By way of example, and not as a limitation, you agree that when using a Communication Service, you will not: defame, abuse, harass, stalk, threaten or otherwise violate the legal rights (such as rights of privacy and publicity) of others; publish, post, upload, distribute or disseminate any inappropriate, profane, defamatory, infringing, obscene, sexually offensive, indecent or unlawful topic, name, material or information; upload files that contain software or other material protected by intellectual property laws (or by rights of privacy of publicity) unless you own or control the rights thereto or have received all necessary consents; upload files that contain viruses, corrupted files, or any other similar software or programs that may damage the operation of another's computer; advertise or offer to sell or buy any goods or services for any business purpose, unless such Communication Service specifically allows such messages; conduct or forward surveys, contests, pyramid schemes or chain letters; download any file posted by another user of a Communication Service that you know, or reasonably should know, cannot be legally distributed in such manner; falsify or delete any author attributions, legal or other proper notices or proprietary designations or labels of the origin or source of software or other material contained in a file that is uploaded; restrict or inhibit any other user from using and enjoying the Communication Services; violate any code of conduct or other guidelines which may be applicable for any particular Communication Service; harvest or otherwise collect information about others, including e-mail addresses, without their consent; or violate any applicable laws or regulations.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Company has no obligation to monitor the Communication Services. However, Company reserves the right to review materials posted to a Communication Service and to remove any materials in its sole discretion. Company reserves the right to terminate your access to any or all of the Communication Services at any time without notice for any reason whatsoever. Company reserves the right at all times to disclose any information as necessary to satisfy any applicable law, regulation, legal process or governmental request, or to edit, refuse to post or to remove any information or materials, in whole or in part, in Company's sole discretion.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Always use caution when giving out any personally identifying information about yourself or your children in any Communication Service. Company does not control or endorse the content, messages or information found in any Communication Service and, therefore, Company specifically disclaims any liability with regard to the Communication Services and any actions resulting from your participation in any Communication Service. Managers and hosts are not authorized Company spokespersons, and their views do not necessarily reflect those of Company. Materials uploaded to a Communication Service may be subject to posted limitations on usage, reproduction and/or dissemination; you are responsible for adhering to such limitations if you upload the materials.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        6. Fees and Payment.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Customer shall pay Company the fees as described on the applicable Order Form ("Fees") in accordance with the due date set forth in Order Form without offset or deduction. Customer shall make all payments hereunder in US dollars on or before the due date as identified in the Order Form. If Customer fails to make any payment when due, without limiting Company's other rights and remedies: (i) Company may charge interest on the past due amount at the rate of 1.5% per month calculated daily and compounded monthly or, if lower, the highest rate permitted under applicable law; (ii) Customer shall reimburse Company for all reasonable costs incurred by Company in collecting any late payments or interest, including attorneys' fees, court costs, and collection agency fees; and (iii) if such failure continues for 30 days or more, Company may suspend, in accordance with Section 2(f), Customer's and all other Authorized Users' access to any portion or all of the Services until such amounts are paid in full.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        All Fees and other amounts payable by Customer under this Agreement are exclusive of taxes and similar assessments. Customer is responsible for all sales, use, and excise taxes, and any other similar taxes, duties, and charges of any kind imposed by any federal, state, or local governmental or regulatory authority on any amounts payable by Customer hereunder, other than any taxes imposed on Company's income.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        <b>Cancellation/Refund Policy</b>: You may cancel your subscription at any time. Company will maintain the account through the end of the current paid month. Please contact us at support@datamerch.com with any questions. Company and its associates reserve the right to refuse or cancel service, terminate accounts, or remove or edit content in our sole discretion.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        7. Confidential Information.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        From time to time during the Term, Company and Customer may disclose or make available to the other party information about its business affairs, products, confidential intellectual property, trade secrets, third-party confidential information, and other sensitive or proprietary information, whether orally or in written, electronic, or other form or media, and whether or not marked, designated, or otherwise identified as "confidential" at the time of disclosure (collectively, "Confidential Information"). Confidential Information does not include information that, at the time of disclosure is: (a) in the public domain; (b) known to the receiving party; (c) rightfully obtained by the receiving party on a non-confidential basis from a third party; or (d) independently developed by the receiving party.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        The receiving party shall not disclose the disclosing party's Confidential Information to any person or entity, except to the receiving party's employees, agents, or subcontractors who have a need to know the Confidential Information for the receiving party to exercise its rights or perform its obligations hereunder and who are required to protect the Confidential Information in a manner no less stringent than required under this Agreement. Notwithstanding the foregoing, each party may disclose Confidential Information to the limited extent required (i) to comply with the order of a court or other governmental body, or as otherwise necessary to comply with applicable law, provided that the party making the disclosure pursuant to the order shall first have given written notice to the other party and made a reasonable effort to obtain a protective order; or (ii) to establish a party's rights under this Agreement, including to make required court filings.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Each party's obligations of non-disclosure with regard to Confidential Information are effective as of the date such Confidential Information is first disclosed to the receiving party and will expire five years thereafter; provided, however, with respect to any Confidential Information that constitutes a trade secret (as determined under applicable law), such obligations of non-disclosure will survive the termination or expiration of this Agreement for as long as such Confidential Information remains subject to trade secret protection under applicable law. Company disclaims any obligation to maintain the confidentiality of information, although its current practice is to utilize reasonable efforts to maintain confidentiality.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        8. Privacy Policy.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Company complies with its privacy policy, available at https://www.datamerch.com/privacy_policy ("Privacy Policy"), in providing the Services. The Privacy Policy is subject to change as described therein. By accessing, using, and providing information to or through the Services, you acknowledge that you have reviewed and accepted our Privacy Policy, and you consent to all actions taken by us with respect to your information in compliance with the then-current version of our Privacy Policy. All Developers and Integration Partners must comply with the Privacy Policy and applicable privacy laws when accessing or processing data via the Services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        User acknowledges and agrees that by providing Company with any user information through the Site, user consents to the transmission of such user information over state, federal, and international borders as necessary for processing in accordance with Company’s standard business practices. User should be aware that Linked Sites may contain transmission of user data provisions that differ from the provisions provided herein; Company is not responsible for such provisions, and expressly disclaims any and all liability related to such provisions.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        9. Intellectual Property Ownership; Feedback.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        As between you and us, (a) we own all right, title, and interest, including all intellectual property rights, in and to the Services and Company IP and (b) As between you and Company, all right, title, and interest, including all intellectual property rights, in and to Customer Data shall be jointly owned by Company and the submitting Customer. A Customer’s ownership interest extends only to the specific Customer Data that such Customer (or its Authorized Users) submitted to the Services. For clarity, Customer has no ownership interest in any data, submissions, content, or other materials submitted to the Services by other customers or users (including any Authorized Users of such other customers), even if Customer may be able to access or view such materials through the Services. Company retains all right, title, and interest in and to the Company IP as defined in Section 1(c). The Services comprise: (1) original works of authorship, including compiled information containing Company selection, arrangement and coordination and expressions of such information or pre-existing material it has created, gathered or assembled; and (2) trade secret and other confidential information. All content included as part of the Service, such as text, graphics, logos, images, as well as the compilation thereof, and any software used on the Site, is the property of Company or its suppliers and protected by copyright and other laws.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        You will not modify, publish, transmit, reverse engineer, participate in the transfer or sale, create derivative works, or in any way exploit any of the content, in whole or in part, found on the Site. You will use protected content solely for your business use, and will make no other use of the content without the express written permission of Company and the copyright owner. Company content is not for resale. Your use of the Site does not entitle you to make any unauthorized use of any protected content, and in particular you will not delete or alter any proprietary rights or attribution notices in any content. You will use protected content solely for your business use. We do not grant you any licenses, express or implied, to the intellectual property of Company or our licensors except as expressly authorized by this Agreement.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        If you or any of your employees, contractors, or agents sends or transmits any communications or materials to us suggesting or recommending changes to the Services, including without limitation, new features or functionality, or any comments, questions, suggestions, or the like ("Feedback"), we are free to use such Feedback irrespective of any other obligation or limitation between you and us governing such Feedback. All Feedback is and will be treated as non-confidential. You hereby assign to us all right, title, and interest in, and we are free to use, without any attribution or compensation to you or any third party, any ideas, know-how, concepts, techniques, or other intellectual property rights contained in the Feedback, for any purpose whatsoever.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        10. Limited Warranty and Warranty Disclaimer.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Company Warranty</b>. Company warrants that it provides Services using a commercially reasonable level of care and skill. THE FOREGOING WARRANTY DOES NOT APPLY, AND COMPANY STRICTLY DISCLAIMS ALL WARRANTIES, WITH RESPECT TO ANY THIRD-PARTY PRODUCTS.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Customer Warranty</b>. You represent and warrant that you own or have sufficient rights, licenses, and permissions to submit Your Customer Data to the Services and to grant the licenses set forth in this Agreement. You further warrant that the submission and use of Your Customer Data in connection with the Services does not violate any applicable law, rule, or regulation, nor infringe upon the intellectual property or proprietary rights of any third party.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>DISCLAIMER</b>. THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE THROUGH THE SITE MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE INFORMATION HEREIN. COMPANY AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE SITE AT ANY TIME.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        EXCEPT FOR THE LIMITED WARRANTY SET FORTH IN SECTION 10(a), THE SERVICES (INCLUDING THE SANDBOX) ARE PROVIDED "AS IS" AND COMPANY SPECIFICALLY DISCLAIMS ALL WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE. COMPANY SPECIFICALLY DISCLAIMS ALL IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT, AND ALL WARRANTIES ARISING FROM COURSE OF DEALING, USAGE, OR TRADE PRACTICE. COMPANY MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS CONTAINED ON THE SITE FOR ANY PURPOSE.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        COMPANY MAKES NO WARRANTY OF ANY KIND THAT THE SERVICES, OR ANY PRODUCTS OR RESULTS OF THE USE THEREOF, WILL MEET YOUR OR ANY OTHER PERSON'S OR ENTITY'S REQUIREMENTS, OPERATE WITHOUT INTERRUPTION, ACHIEVE ANY INTENDED RESULT, BE COMPATIBLE OR WORK WITH ANY OF YOUR OR ANY THIRD PARTY'S SOFTWARE, SYSTEM, OR OTHER SERVICES, OR BE SECURE, ACCURATE, COMPLETE, FREE OF HARMFUL CODE, OR ERROR-FREE, OR THAT ANY ERRORS OR DEFECTS CAN OR WILL BE CORRECTED. COMPANY WILL NOT BE RESPONSIBLE FOR ANY DAMAGE USER SUFFERS FROM USE OF THE WEBSITE. USE OF ANY INFORMATION OBTAINED VIA THE WEBSITE IS AT YOUR OWN RISK.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        11. Indemnification.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Provider Indemnification</b>. (i) Company shall indemnify, defend, and hold Customer harmless from and against any and all losses, damages, liabilities, deficiencies, claims, actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including reasonable attorneys' fees ("Losses"), incurred by Customer resulting from any third-party claim, suit, action, or proceeding ("Third-Party Claim") that the Services, or any use of the Services in accordance with this Agreement, infringes or misappropriates such third party's US intellectual property rights, provided that Customer promptly notifies Company in writing of the Third-Party Claim, cooperates with Company, and allows Company sole authority to control the defense and settlement of such Third-Party Claim. (ii) If such a Third-Party Claim is made or either party reasonably anticipates such a Third-Party Claim will be made, Customer agrees to permit Company, at Company's sole discretion, to (A) modify or replace the Services, or component or part thereof, to make it non-infringing, or (B) obtain the right for Customer to continue use. If Company determines that neither alternative is reasonably available, Company may terminate this Agreement, in its entirety or with respect to the affected component or part, effective immediately on written notice to Customer. This Section 11(a)(ii) sets forth your sole remedies and our sole liability and obligation for any actual, threatened, or alleged Third-Party Claims that the Services infringe, misappropriate, or otherwise violate any intellectual property rights of any third party. (iii) This Section 11(a) will not apply to the extent that any such Third-Party Claim arises from Customer Data or Third-Party Products.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Customer Indemnification</b>. Customer shall indemnify, hold harmless, and, at Company's option, defend Company and its officers, directors, employees, agents, affiliates, successors, and assigns from and against any and all Losses arising from or relating to any Third-Party Claim: (i) that the Customer Data, or any use of the Customer Data in accordance with this Agreement, infringes or misappropriates such third party's US intellectual property rights; (ii) based on Customer's or any Authorized User's negligence or willful misconduct or use of the Services in a manner not authorized by this Agreement; (iii) relating to or arising out of your use of or inability to use the Site or services; (iv) any user postings or Submissions made by you; (v) your violation of any terms of this Agreement; or (vi) your violation of any applicable laws, rules or regulations. Customer may not settle, compromise, or in any other manner dispose of any Third-Party Claim against Company unless Company consents to such settlement, and further provided that Company will have the right, at its own cost, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you, in which event you will fully cooperate with Company in asserting any available defenses.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        12. Limitations of Liability.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>COMPANY LIABILITY</b>. IN NO EVENT WILL COMPANY BE LIABLE UNDER OR IN CONNECTION WITH THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR OTHERWISE, FOR ANY: (a) CONSEQUENTIAL, INCIDENTAL, INDIRECT, EXEMPLARY, SPECIAL, ENHANCED, OR PUNITIVE DAMAGES; (b) INCREASED COSTS, DIMINUTION IN VALUE OR LOST BUSINESS, PRODUCTION, REVENUES, OR PROFITS; (c) LOSS OF GOODWILL OR REPUTATION; (d) USE, INABILITY TO USE, LOSS, INTERRUPTION, DELAY OR RECOVERY OF ANY DATA, OR BREACH OF DATA OR SYSTEM SECURITY; OR (e) COST OF REPLACEMENT GOODS OR SERVICES, IN EACH CASE REGARDLESS OF WHETHER COMPANY WAS ADVISED OF THE POSSIBILITY OF SUCH LOSSES OR DAMAGES OR SUCH LOSSES OR DAMAGES WERE OTHERWISE FORESEEABLE.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        IN NO EVENT WILL COMPANY’S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR OTHERWISE EXCEED THE TOTAL AMOUNTS PAID TO COMPANY UNDER THIS AGREEMENT IN THE TWELVE (12) MONTH PERIOD PRECEDING THE EVENT GIVING RISE TO THE CLAIM. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THE SITE.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>State Law Rights</b>. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, the above limitations may not apply to you. In such jurisdictions, Company’s liability shall be limited to the maximum extent permitted by law.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        13. Term and Termination.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Term</b>. The term of this Agreement begins on the Effective Date and continues until terminated in accordance with the Order Form, or until Customer requests the cancellation of service from Company. Services that are specified to automatically renew will renew in accordance with the Order Form unless earlier terminated pursuant to this Agreement's express provisions or either party gives the other party written notice of non-renewal.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Termination</b>. In addition to any other express termination right set forth in this Agreement: (i) Company may terminate this Agreement for any reason upon thirty (30) days' advance notice. Company further reserves the right, in its sole discretion, to terminate your access to the Site and the related services or any portion thereof at any time, without notice. (ii) Either party may terminate this Agreement, effective on written notice to the other party, if the other party materially breaches this Agreement, and such breach: (A) is incapable of cure; or (B) being capable of cure, remains uncured 30 days after the non-breaching party provides the breaching party with written notice of such breach. Company may terminate this Agreement immediately upon written notice if Customer or its Integration Partner breaches the restrictions in Section 3 regarding credential pooling or subscription circumvention. (iii) Either party may terminate this Agreement, effective immediately upon written notice to the other party, if the other party: (A) becomes insolvent or is generally unable to pay, or fails to pay, its debts as they become due; (B) files, or has filed against it, a petition for voluntary or involuntary bankruptcy or otherwise becomes subject, voluntarily or involuntarily, to any proceeding under any domestic or foreign bankruptcy or insolvency law; (C) makes or seeks to make a general assignment for the benefit of its creditors; or (D) applies for or has appointed a receiver, trustee, custodian, or similar agent appointed by order of any court of competent jurisdiction to take charge of or sell any material portion of its property or business.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>Effect of Termination</b>. Upon termination of this Agreement, Customer shall immediately discontinue use of the Company IP. No expiration or termination of this Agreement will affect Customer's obligation to pay all Fees that may have become due before such expiration or termination, or entitle Customer to any refund.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>Survival</b>. This Section 13(d), Sections 7, 8, 9, 12, 13, 16, 17, and any right, obligation, or required performance of the parties in this Agreement which, by its express terms or nature and context is intended to survive termination or expiration of this Agreement, will survive any such termination or expiration.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        14. Modifications.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        You acknowledge and agree that we have the right, in our sole discretion, to modify this Agreement from time to time, and that modified terms become effective on posting. You will be notified of modifications through direct email communication from us or an update on our website. You are responsible for reviewing and becoming familiar with any such modifications; Company encourages you to periodically review our website to stay informed of our updates. Your continued use of the Services after the effective date of the modifications will be deemed acceptance of the modified terms. Company will provide at least 30 days' advance notice of changes to any service level that Company reasonably anticipates may result in a material reduction in quality or services.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        15. Export Regulation and International Users.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        The Services utilize software and technology that may be subject to US export control laws, including the US Export Administration Act and its associated regulations. You shall not, directly or indirectly, export, re-export, or release the Services or the software or technology included in the Services to, or make the Services accessible from, any jurisdiction or country to which export, re-export, or release is prohibited by law, regulation, or rule. You shall comply with all applicable federal laws, regulations, and rules, and complete all required undertakings prior to making the Services available outside the US. The Service is controlled, operated and administered by Company from our offices within the USA. If you access the Service from a location outside the USA, you are responsible for compliance with all local laws.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        16. Governing Law and Binding Arbitration.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Governing Law</b>. This agreement is governed by and construed in accordance with the internal laws of Florida without giving effect to any choice or conflict of law provision or rule. To the maximum extent permitted by law, you hereby consent to the exclusive jurisdiction and venue of courts in Florida in all disputes arising out of or relating to the use of the Site. Use of the Site is unauthorized in any jurisdiction that does not give effect to all provisions of this Agreement, including, without limitation, this section.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Binding Arbitration</b>. (i) Any dispute in relation to this Agreement will be resolved through arbitration, unless otherwise prohibited by applicable laws. If you would like to opt-out of binding arbitration, please notify us within 30 days of your acceptance of this Agreement by emailing (ii) This provision facilitates the prompt and efficient resolution of any dispute that may arise between you and us. The term “dispute” is given the broadest meaning enforceable by law and includes any claims against other parties relating to services or products provided by us or billed to you whenever you also assert claims against us in the same proceeding. (iii) All disputes between you and us will be resolved by binding arbitration because acceptance of this Agreement constitutes a waiver of your right to litigate claims and all opportunity to be heard by a judge or jury. YOU AND COMPANY AGREE THAT ANY AND ALL DISPUTES, WHETHER PRESENTLY IN EXISTENCE OR BASED ON ACTS OR OMISSIONS IN THE PAST OR IN THE FUTURE, WILL BE RESOLVED EXCLUSIVELY AND FINALLY BY BINDING ARBITRATION RATHER THAN IN COURT. (iv) Pre-Arbitration Claim Resolution. For all disputes, you must first give us an opportunity to cure or resolve the dispute by emailing to support@datamerch.com: (1) your name, (2) your address, (3) a written description of your claim, and (4) a description of the specific relief you seek. If we do not resolve the dispute within 45 days after receiving your notification, then you may pursue your dispute in arbitration. (v) Arbitration Procedures. JAMS, www.jamsadr.com, will arbitrate all disputes, and the arbitration will be conducted before a single arbitrator. The arbitration will be commenced as an individual arbitration, and will in no event be commenced as a class arbitration. Under no circumstances will class action procedures or rules apply to the arbitration. The Federal Arbitration Act (“FAA”) governs the arbitrability of all disputes. (vi) Class Action Waiver. The arbitrator may not consolidate more than one person’s claims, and may not otherwise preside over any form of a class or representative proceeding or claims (such as a class action, consolidated action or private attorney general action) unless both you and us specifically agree to do so following initiation of the arbitration. (vii) You understand and agree that by accepting this provision, you and we are each waiving the right to a jury trial or a trial before a judge in a public court. If the Class Action Waiver clause is found to be illegal or unenforceable, this entire provision will be unenforceable and the dispute will be decided by a court.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        17. Dispute Policy.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (a) <b>Dispute Policy Incorporated</b>. Company maintains a dispute process and related policy governing disputes submitted regarding the accuracy or validity of Records made available through the Services (the “Dispute Policy”). The Dispute Policy is incorporated into and made part of this Agreement by reference, as though fully set forth herein. The then-current Dispute Policy will be made available at https://www.datamerch.com/dispute_process (or another location designated by Company).
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (b) <b>Applicability; Dispute Submissions</b>. To the extent a Customer, Authorized User, Merchant, or other user submits, responds to, or otherwise participates in a dispute through the Services, such person agrees to comply with the Dispute Policy and acknowledges that the Dispute Policy governs Company’s intake, administration, processing, communications, determinations, updates, and closure of disputes.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (c) <b>Order of Precedence for Dispute Mechanics</b>. If there is any conflict between the Dispute Policy and this Agreement solely with respect to dispute-related procedures (including eligibility, submission standards, required information, timelines, investigation steps, communications, determinations, and record update protocols), the Dispute Policy controls for those procedure-specific matters. For all other matters, this Agreement controls.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        (d) <b>Updates to Dispute Policy</b>. Company may update the Dispute Policy from time to time consistent with Section 14 (Modifications). Unless Company expressly states otherwise, updates apply prospectively; however, Company may apply updated administrative procedures to pending disputes where reasonably necessary to operate the dispute process.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="h4"
      >
        18. Miscellaneous.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        This Agreement, together with (a) the Privacy Policy, (b) the Dispute Policy, and (c) any applicable Order Form (collectively, the “Governing Terms”), constitutes the entire agreement and understanding between the parties regarding access to and use of the Site and Services and supersedes all prior or contemporaneous communications and proposals, whether electronic, oral, or written, regarding the Site and Services. In the event of any direct conflict or inconsistency between this Agreement and the Privacy Policy, this Agreement controls.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Any notices to us must be sent to 23110 State Rd 54 #247, Lutz, FL 33549 and must be delivered either in person, by certified or registered mail, email with return receipt requested, or by recognized overnight courier service. You hereby consent to receiving electronic communications from us. You agree that any notices, agreements, disclosures, or other communications that we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communications be in writing.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Company’s performance of this agreement is subject to existing laws and legal process, and nothing contained in this agreement is in derogation of Company’s right to comply with governmental, court and law enforcement requests or requirements relating to your use of the Site or information provided to or gathered by Company with respect to such use.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Company will not be liable for failing to perform under this Agreement by the occurrence of any event beyond its reasonable control, including, without limitation, a labor disturbance, an internet outage or interruption of services, communications outage or failure due to fire, terrorism, natural disaster or war. No joint venture, partnership, employment, or agency relationship exists between you and Company as a result of this agreement or use of the Site.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        The invalidity, illegality, or unenforceability of any provision herein does not affect any other provision. If any part of this agreement is determined to be invalid or unenforceable, then the invalid or unenforceable provision will be deemed superseded by a valid, enforceable provision that most closely matches the intent of the original provision and the remainder of the agreement shall continue in effect. Any failure to act by us with respect to a breach does not constitute a waiver. This Agreement is personal to you and may not be assigned or transferred for any reason whatsoever without our prior written consent. It is the express wish to the parties that this agreement and all related documents be written in English. A printed version of this agreement and of any notice given in electronic form shall be admissible in judicial or administrative proceedings based upon or relating to this agreement to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form.
      </Typography>
      <Typography
        sx={{
                marginTop: '15px'
              }}
        variant="subtitle2"
      >
        Contact Us: Company 23110 State Rd #54, Lutz, FL 33549 Email Address: support@datamerch.com Telephone number: 866-549-3114
      </Typography>
    </React.Fragment>
  )
}

export default Terms2;
